window.theme = window.theme || {};
window.theme = window.theme || {};
theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document)
  .on('shopify:section:load', this._onSectionLoad.bind(this))
  .on('shopify:section:unload', this._onSectionUnload.bind(this))
  .on('shopify:section:select', this._onSelect.bind(this))
  .on('shopify:section:deselect', this._onDeselect.bind(this))
  .on('shopify:block:select', this._onBlockSelect.bind(this))
  .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};
theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];
    if (_.isUndefined(constructor)) {
      return;
    }
    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;
      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }
      return !isEventInstance;
    });
  },
  _onSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },
  _onBlockSelect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function(evt) {
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });
    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },
  register: function(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});
window.slate = window.slate || {};
slate.utils = {
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },
  keyboardKeys: {
    TAB: 9,
    ENTER: 13
  }
};
window.slate = window.slate || {};
slate.rte = {
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');
      this.src = this.src;
    });
  }
};
window.slate = window.slate || {};
slate.a11y = {
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';
    $element
    .first()
    .attr('tabIndex', '-1')
    .focus()
    .addClass(focusClass)
    .one('blur', callback);
    function callback() {
      $element
      .first()
      .removeClass(focusClass)
      .removeAttr('tabindex');
    }
  },
  focusHash: function() {
    var hash = window.location.hash;
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
      ? 'focusout.' + options.namespace
      : 'focusout',
      keydown: options.namespace
      ? 'keydown.' + options.namespace
      : 'keydown.handleFocus'
    };
    var $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];
    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }
    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }
    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    $(document).off('focusin');
    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });
    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;
      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },
  removeTrapFocus: function(options) {
    var eventName = options.namespace
    ? 'focusin.' + options.namespace
    : 'focusin';
    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    $(document).off(eventName);
  },
  accessibleLinks: function(options) {
    var body = document.querySelector('body');
    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };
    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }
    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }
      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );
      var container = document.createElement('ul');
      var htmlMessages = '';
      for (var message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }
      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;
      body.appendChild(container);
    }
    function _externalSite($link) {
      var hostname = window.location.hostname;
      return $link[0].hostname !== hostname;
    }
    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';
      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function(i, val) {
            var relValue = val === undefined ? '' : val + ' ';
            return relValue + 'noopener';
          });
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });
    generateHTML(options.messages);
  }
};
theme.Images = (function() {
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }
    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }
  function loadImage(path) {
    new Image().src = path;
  }
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);
    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );
    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }
    if (size === 'master') {
      return this.removeProtocol(src);
    }
    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );
    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }
    return null;
  }
  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }
  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();
theme.Currency = (function() {
  var moneyFormat = '${{amount}}';
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number === null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney
  };
})();
slate.Variants = (function() {
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }
  Variants.prototype = _.assignIn({}, Variants.prototype, {
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};
          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');
              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            return currentOption;
          }
        }
      );
      currentOptions = _.compact(currentOptions);
      return currentOptions;
    },
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });
      return found;
    },
    _onSelectChange: function( selector) {
      var variant = this._getVariantFromOptions();
      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });
      if (!variant) {
        return;
      }
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
      if (variant) {
        var form = jQuery('#' + selector.domIdPrefix).closest('form');
        for (var i=0,length=variant.options.length; i<length; i++) {
          var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
          if (radioButton.size()) {
            radioButton.get(0).checked = true;
          }
        }
      }
    },
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};
      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        return;
      }
      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }
      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }
      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }
      var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          '?variant=' +
          variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });
  return Variants;
})();
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };
    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };
    this.config = $.extend(defaults, options);
    this.position = position;
    this.$drawer = $('#' + id);
    if (!this.$drawer.length) {
      return false;
    }
    this.drawerIsOpen = false;
    this.init();
  }
  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };
  Drawer.prototype.open = function(evt) {
    var externalCall = false;
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      this.$activeSource = $(evt.currentTarget);
    }
    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }
    this.$drawer.prepareTransition();
    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }
    this.bindEvents();
    return this;
  };
  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      return;
    }
    $(document.activeElement).trigger('blur');
    this.$drawer.prepareTransition();
    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );
    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }
    this.drawerIsOpen = false;
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });
    this.unbindEvents();
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose();
    }
  };
  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });
    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };
  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };
  return Drawer;
})();
window.theme = window.theme || {};
theme.Header = (function() {
  var selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last'
  };
  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };
  var cache = {};
  function init() {
    cacheSelectors();
    cache.$parents.on('click.siteNav', function() {
      var $el = $(this);
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el);
    });
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return;
        }
        hideDropdown(cache.$activeDropdown);
      });
    });
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });
    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      evt.stopImmediatePropagation();
    });
    $(selectors.multicurrencySelector).on('change', function() {
      $(this)
      .parents('form')
      .submit();
    });
  }
  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown)
    };
  }
  function showDropdown($el) {
    $el.addClass(config.activeClass);
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }
    cache.$activeDropdown = $el;
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');
    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });
      $(selectors.body).on('click.siteNav', function() {
        hideDropdown($el);
      });
    }, 250);
  }
  function hideDropdown($el) {
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);
    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }
  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
  }
  return {
    init: init,
    unload: unload
  };
})();
window.theme = window.theme || {};
theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;
  var mediaQuerySmall = 'screen and (max-width: 749px)';
  function init() {
    cacheSelectors();
    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }
  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }
  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }
  function openMobileNav() {
    var translateHeaderHeight = cache.$siteHeader.outerHeight();
    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });
    cache.$pageContainer.css({
      transform:
      'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    });
    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });
    cache.$mobileNavToggle
    .addClass(classes.mobileNavCloseIcon)
    .removeClass(classes.mobileNavOpenIcon)
    .attr('aria-expanded', true);
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }
  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);
    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });
    cache.$pageContainer.removeAttr('style');
    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });
    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );
    cache.$mobileNavToggle
    .addClass(classes.mobileNavOpenIcon)
    .removeClass(classes.mobileNavCloseIcon)
    .attr('aria-expanded', false)
    .focus();
    $(window).off('keyup.mobileNav');
    scrollTo(0, 0);
  }
  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }
    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;
    if (isReturn) {
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive);
      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }
    $activeTrigger = $toggleBtn;
    goToSubnav($toggleBtn.data('target'));
  }
  function goToSubnav(target) {
    var $targetMenu = target
    ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
    : cache.$mobileNav;
    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;
    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }
    $activeSubNav = $targetMenu;
    var translateMenuHeight = $targetMenu.outerHeight();
    var openNavClass =
        menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
    cache.$mobileNavContainer
    .css('height', translateMenuHeight)
    .removeClass(classes.thirdNavShowing)
    .addClass(openNavClass);
    if (!target) {
      cache.$mobileNavContainer
      .removeClass(classes.thirdNavShowing)
      .removeClass(classes.subNavShowing);
    }
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;
    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });
        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });
    $activeSubNav.removeClass(classes.subNavClosing);
  }
  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);
window.theme = window.theme || {};
theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',
    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',
    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',
    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',
    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',
    mobileNavWrapper: '.mobile-nav-wrapper'
  };
  var classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open'
  };
  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }
    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);
    initDrawer();
    var isSearchPage =
        slate.utils.getParameterByName('q') !== null &&
        window.location.pathname === '/search';
    if (isSearchPage) {
      validateSearchResultForm.call(this);
    }
    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    );
    $(selectors.searchHeaderInput)
    .add(selectors.searchHeaderSubmit)
    .on('focus blur', function() {
      $(selectors.searchHeader).toggleClass(classes.focus);
    });
    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;
      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }
  function initDrawer() {
    $('#PageContainer').addClass('drawer-page-content');
    $('.js-drawer-open-top')
    .attr('aria-controls', 'SearchDrawer')
    .attr('aria-expanded', 'false')
    .attr('aria-haspopup', 'dialog');
    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    });
  }
  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));
    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }
  function searchFocus($el) {
    $el.focus();
    $el[0].setSelectionRange(0, $el[0].value.length);
  }
  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
    .removeAttr('aria-describedby')
    .removeAttr('aria-invalid');
  }
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
    .attr('aria-describedby', 'error-search-form')
    .attr('aria-invalid', true);
  }
  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;
    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }
    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }
    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }
  return {
    init: init
  };
})();
(function() {
  var selectors = {
    backButton: '.return-link'
  };
  var $backButton = $(selectors.backButton);
  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }
  $backButton.one('click', function(evt) {
    evt.preventDefault();
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);
    if (shopDomain === referrerDomain) {
      history.back();
    }
    return false;
  });
  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;
    return anchor.hostname;
  }
})();
theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };
  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);
    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };
    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
    this.$pause.on('click', this.togglePause.bind(this));
  }
  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;
    $list.removeAttr('aria-live');
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }
      $list.attr('aria-live', 'polite');
      if (autoplay) {
        $slider.slick('slickPause');
      }
    });
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }
      $list.removeAttr('aria-live');
      if (autoplay) {
        if ($(evt.target).hasClass(classes.closeVideoBtn)) {
          return;
        }
        $slider.slick('slickPlay');
      }
    });
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }
        if (evt.which === 39) {
          $slider.slick('slickNext');
        }
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }
  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $currentSlide = $slider.find('.' + classes.currentSlide);
    var $nextSlide = $slider.find(
      '.slideshow__slide[data-slick-index="' + nextSlide + '"]'
    );
    if (isVideoInSlide($currentSlide)) {
      var $currentVideo = $currentSlide.find('.' + classes.video);
      var currentVideoId = $currentVideo.attr('id');
      theme.SlideshowVideo.pauseVideo(currentVideoId);
      $currentVideo.attr('tabindex', '-1');
    }
    if (isVideoInSlide($nextSlide)) {
      var $video = $nextSlide.find('.' + classes.video);
      var videoId = $video.attr('id');
      var isBackground = $video.hasClass(classes.videoBackground);
      if (isBackground) {
        theme.SlideshowVideo.playVideo(videoId);
      } else {
        $video.attr('tabindex', '0');
      }
    }
  }
  function isVideoInSlide($slide) {
    return $slide.find('.' + classes.video).length;
  }
  slideshow.prototype.togglePause = function() {
    var slideshowSelector = getSlideshowId(this.$pause);
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused);
      $(slideshowSelector).slick('slickPlay');
    } else {
      this.$pause.addClass(classes.isPaused);
      $(slideshowSelector).slick('slickPause');
    }
  };
  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }
  return slideshow;
})();
function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
theme.SlideshowVideo = (function() {
  var autoplayCheckComplete = false;
  var autoplayAvailable = false;
  var playOnClickChecked = false;
  var playOnClick = false;
  var youtubeLoaded = false;
  var videos = {};
  var videoPlayers = [];
  var videoOptions = {
    ratio: 16 / 9,
    playerVars: {
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      showinfo: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  };
  var classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    slideshowWrapper: 'slideshow-wrapper',
    slide: 'slideshow__slide',
    slideBackgroundVideo: 'slideshow__slide--background-video',
    slideDots: 'slick-dots',
    videoChrome: 'slideshow__video--chrome',
    videoBackground: 'slideshow__video--background',
    playVideoBtn: 'slideshow__video-control--play',
    closeVideoBtn: 'slideshow__video-control--close',
    currentSlide: 'slick-current',
    slickClone: 'slick-cloned',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay'
  };
  function init($video) {
    if (!$video.length) {
      return;
    }
    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status: $video.data('type') === 'chrome' ? 'closed' : 'background',
      videoSelector: $video.attr('id'),
      $parentSlide: $video.closest('.' + classes.slide),
      $parentSlideshowWrapper: $video.closest('.' + classes.slideshowWrapper),
      controls: $video.data('type') === 'background' ? 0 : 1,
      slideshow: $video.data('slideshow')
    };
    if (!youtubeLoaded) {
      var tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      var firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  function customPlayVideo(playerId) {
    if (!playOnClickChecked && !playOnClick) {
      return;
    }
    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId);
    }
  }
  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo();
    }
  }
  function loadVideos() {
    for (var key in videos) {
      if (videos.hasOwnProperty(key)) {
        var args = $.extend({}, videoOptions, videos[key]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(key, args);
      }
    }
    initEvents();
    youtubeLoaded = true;
  }
  function loadVideo(key) {
    if (!youtubeLoaded) {
      return;
    }
    var args = $.extend({}, videoOptions, videos[key]);
    args.playerVars.controls = args.controls;
    videoPlayers[key] = new YT.Player(key, args);
    initEvents();
  }
  function privatePlayVideo(id, clicked) {
    var videoData = videos[id];
    var player = videoPlayers[id];
    var $slide = videos[id].$parentSlide;
    if (playOnClick) {
      setAsPlaying(videoData);
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      $slide.removeClass(classes.loading);
      setAsPlaying(videoData);
      player.playVideo();
      return;
    }
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $slide);
    }
  }
  function setAutoplaySupport(supported) {
    var supportClass = supported
    ? classes.supportsAutoplay
    : classes.supportsNoAutoplay;
    $(document.documentElement).addClass(supportClass);
    if (!supported) {
      playOnClick = true;
    }
    autoplayCheckComplete = true;
  }
  function autoplayCheckFunction(player, $slide) {
    player.playVideo();
    autoplayTest(player)
    .then(function() {
      setAutoplaySupport(true);
    })
    .fail(function() {
      setAutoplaySupport(false);
      player.stopVideo();
    })
    .always(function() {
      autoplayCheckComplete = true;
      $slide.removeClass(classes.loading);
    });
  }
  function autoplayTest(player) {
    var deferred = $.Deferred();
    var wait;
    var timeout;
    wait = setInterval(function() {
      if (player.getCurrentTime() <= 0) {
        return;
      }
      autoplayAvailable = true;
      clearInterval(wait);
      clearTimeout(timeout);
      deferred.resolve();
    }, 500);
    timeout = setTimeout(function() {
      clearInterval(wait);
      deferred.reject();
    }, 4000);
    return deferred;
  }
  function playOnClickCheck() {
    if (playOnClickChecked) {
      return;
    }
    if ($(window).width() < 750) {
      playOnClick = true;
    } else if (window.mobileCheck()) {
      playOnClick = true;
    }
    if (playOnClick) {
      setAutoplaySupport(false);
    }
    playOnClickChecked = true;
  }
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080');
    var videoData = getVideoOptions(evt);
    playOnClickCheck();
    $('#' + videoData.id).attr('tabindex', '-1');
    sizeBackgroundVideos();
    switch (videoData.type) {
      case 'background-chrome':
      case 'background':
        evt.target.mute();
        if (videoData.$parentSlide.hasClass(classes.currentSlide)) {
          privatePlayVideo(videoData.id);
        }
        break;
    }
    videoData.$parentSlide.addClass(classes.loaded);
  }
  function onPlayerChange(evt) {
    var videoData = getVideoOptions(evt);
    switch (evt.data) {
      case 0:
        setAsFinished(videoData);
        break;
      case 1:
        setAsPlaying(videoData);
        break;
      case 2:
        setAsPaused(videoData);
        break;
    }
  }
  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0);
        break;
      case 'background-chrome':
        videoPlayers[videoData.id].seekTo(0);
        closeVideo(videoData.id);
        break;
      case 'chrome':
        closeVideo(videoData.id);
        break;
    }
  }
  function setAsPlaying(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    $slide.removeClass(classes.loading);
    if (videoData.status === 'background') {
      return;
    }
    $('#' + videoData.id).attr('tabindex', '0');
    switch (videoData.type) {
      case 'chrome':
      case 'background-chrome':
        $slideshow.removeClass(classes.paused).addClass(classes.playing);
        $slide.removeClass(classes.paused).addClass(classes.playing);
        break;
    }
    $slide.find('.' + classes.closeVideoBtn).focus();
  }
  function setAsPaused(videoData) {
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    if (videoData.type === 'background-chrome') {
      closeVideo(videoData.id);
      return;
    }
    if (videoData.status !== 'closed' && videoData.type !== 'background') {
      $slideshow.addClass(classes.paused);
      $slide.addClass(classes.paused);
    }
    if (videoData.type === 'chrome' && videoData.status === 'closed') {
      $slideshow.removeClass(classes.paused);
      $slide.removeClass(classes.paused);
    }
    $slideshow.removeClass(classes.playing);
    $slide.removeClass(classes.playing);
  }
  function closeVideo(playerId) {
    var videoData = videos[playerId];
    var $slideshow = videoData.$parentSlideshowWrapper;
    var $slide = videoData.$parentSlide;
    var classesToRemove = [classes.pause, classes.playing].join(' ');
    $('#' + videoData.id).attr('tabindex', '-1');
    videoData.status = 'closed';
    switch (videoData.type) {
      case 'background-chrome':
        videoPlayers[playerId].mute();
        setBackgroundVideo(playerId);
        break;
      case 'chrome':
        videoPlayers[playerId].stopVideo();
        setAsPaused(videoData);
        break;
    }
    $slideshow.removeClass(classesToRemove);
    $slide.removeClass(classesToRemove);
  }
  function getVideoOptions(evt) {
    return videos[evt.target.h.id];
  }
  function startVideoOnClick(playerId) {
    var videoData = videos[playerId];
    videoData.$parentSlide.addClass(classes.loading);
    videoData.status = 'open';
    switch (videoData.type) {
      case 'background-chrome':
        unsetBackgroundVideo(playerId, videoData);
        videoPlayers[playerId].unMute();
        privatePlayVideo(playerId, true);
        break;
      case 'chrome':
        privatePlayVideo(playerId, true);
        break;
    }
    $(document).on('keydown.videoPlayer', function(evt) {
      if (evt.keyCode === 27) {
        closeVideo(playerId);
      }
    });
  }
  function sizeBackgroundVideos() {
    $('.' + classes.videoBackground).each(function(index, el) {
      sizeBackgroundVideo($(el));
    });
  }
  function sizeBackgroundVideo($player) {
    var $slide = $player.closest('.' + classes.slide);
    if ($slide.hasClass(classes.slickClone)) {
      return;
    }
    var slideWidth = $slide.width();
    var playerWidth = $player.width();
    var playerHeight = $player.height();
    if (slideWidth / videoOptions.ratio < playerHeight) {
      playerWidth = Math.ceil(playerHeight * videoOptions.ratio);
      $player
      .width(playerWidth)
      .height(playerHeight)
      .css({
        left: (slideWidth - playerWidth) / 2,
        top: 0
      });
    } else {
      playerHeight = Math.ceil(slideWidth / videoOptions.ratio);
      $player
      .width(slideWidth)
      .height(playerHeight)
      .css({
        left: 0,
        top: (playerHeight - playerHeight) / 2
      });
    }
    $player.prepareTransition().addClass(classes.loaded);
  }
  function unsetBackgroundVideo(playerId) {
    $('#' + playerId)
    .removeAttr('style')
    .removeClass(classes.videoBackground)
    .addClass(classes.videoChrome);
    videos[playerId].$parentSlideshowWrapper
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);
    videos[playerId].$parentSlide
    .removeClass(classes.slideBackgroundVideo)
    .addClass(classes.playing);
    videos[playerId].status = 'open';
  }
  function setBackgroundVideo(playerId) {
    var $player = $('#' + playerId)
    .addClass(classes.videoBackground)
    .removeClass(classes.videoChrome);
    videos[playerId].$parentSlide.addClass(classes.slideBackgroundVideo);
    videos[playerId].status = 'background';
    sizeBackgroundVideo($player);
  }
  function initEvents() {
    $(document).on('click.videoPlayer', '.' + classes.playVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      startVideoOnClick(playerId);
    });
    $(document).on('click.videoPlayer', '.' + classes.closeVideoBtn, function(
                   evt
    ) {
      var playerId = $(evt.currentTarget).data('controls');
      closeVideo(playerId);
    });
    $(window).on(
      'resize.videoPlayer',
      $.debounce(250, function() {
        if (youtubeLoaded) {
          sizeBackgroundVideos();
        }
      })
    );
  }
  function removeEvents() {
    $(document).off('.videoPlayer');
    $(window).off('.videoPlayer');
  }
  return {
    init: init,
    loadVideos: loadVideos,
    loadVideo: loadVideo,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  };
})();
window.theme = window.theme || {};
theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };
  function init() {
    this.$statusMessage = $(selectors.statusMessage);
    if (!this.$statusMessage) return;
    this.$statusMessage.focus();
  }
  return {
    init: init
  };
})();
(function() {
  var $filterBy = $('#BlogTagFilter');
  if (!$filterBy.length) {
    return;
  }
  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();
window.theme = theme || {};
theme.customerTemplates = (function() {
  function initEventListeners() {
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');
    if (!$formState.length) {
      return;
    }
    $('#ResetSuccess').removeClass('hide');
  }
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');
    if (!$newAddressForm.length) {
      return;
    }
    if (Shopify) {
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
    $('button.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }
  function checkUrlHash() {
    var hash = window.location.hash;
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }
  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();
window.theme = window.theme || {};
theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };
  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };
  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);
    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }
    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);
    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }
  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },
    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';
      $evtTarget
      .toggleClass(config.showEditClass)
      .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },
    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },
    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');
      window.location.href = url;
    },
    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;
      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });
  return Cart;
})();
window.theme = window.theme || {};
theme.Filters = (function() {
  var settings = {
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };
  var constants = {
    SORT_BY: 'sort_by'
  };
  var selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };
  function Filters(container) {
    var $container = (this.$container = $(container));
    this.$filterSelect = $(selectors.filterSelection, $container);
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    );
    this.defaultSort = this._getDefaultSortValue();
    this.$selects.removeClass('hidden');
    this.$filterSelect.on('change', this._onFilterChange.bind(this));
    this.$sortSelect.on('change', this._onSortChange.bind(this));
    this._initBreakpoints();
  }
  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function() {
      var self = this;
      enquire.register(settings.mediaQueryMediumUp, {
        match: function() {
          self._resizeSelect(self.$selects);
        }
      });
    },
    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');
      var queryStringValue = slate.utils.getParameterByName('q');
      var query = queryStringValue !== null ? queryStringValue : '';
      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        query = query !== '' ? '?q=' + query + '&' : '?';
        window.location.href =
          urlStripped + query + sort ;
      } else {
        window.location.href = url;
      }
    },
    _onFilterChange: function() {
      var filter = this._getFilterValue();
      var search = document.location.search.replace(/\?(page=\w+)?&?/, '');
      search = search !== '' ? '?' + search : '';
      document.location.href = filter + search ;
    },
    _getFilterValue: function() {
      return this.$filterSelect.val();
    },
    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },
    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },
    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';
      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }
      return query;
    },
    _resizeSelect: function($selection) {
      $selection.each(function() {
        var $this = $(this);
        var arrowWidth = 10;
        var text = $this.find('option:selected').text();
        var $test = $('<span>').html(text);
        $test.appendTo('body');
        var width = $test.width();
        $test.remove();
        $this.width(width + arrowWidth);
      });
    },
    onUnload: function() {
      this.$filterSelect.off('change', this._onFilterChange);
      this.$sortSelect.off('change', this._onSortChange);
    }
  });
  return Filters;
})();
window.theme = window.theme || {};
theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }
  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });
  return Header;
})();
theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];
  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };
  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };
  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }
    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    );
  };
  function Map(container) {
    this.$container = $(container);
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');
    if (typeof this.key === 'undefined') {
      return;
    }
    if (apiStatus === 'loaded') {
      this.createMap();
    } else {
      mapsToLoad.push(this);
      if (apiStatus !== 'loading') {
        apiStatus = 'loading';
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function() {
            apiStatus = 'loaded';
            initAllMaps();
          });
        }
      }
    }
  }
  function initAllMaps() {
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }
  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');
    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }
      deferred.resolve(results);
    });
    return deferred;
  }
  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function() {
      var $map = this.$map;
      return geolocate($map)
      .then(
        function(results) {
          var mapOptions = {
            zoom: config.zoom,
            center: results[0].geometry.location,
            draggable: false,
            clickableIcons: false,
            scrollwheel: false,
            disableDoubleClickZoom: true,
            disableDefaultUI: true
          };
          var map = (this.map = new google.maps.Map($map[0], mapOptions));
          var center = (this.center = map.getCenter());
          var marker = new google.maps.Marker({
            map: map,
            position: map.getCenter()
          });
          google.maps.event.addDomListener(
            window,
            'resize',
            $.debounce(250, function() {
              google.maps.event.trigger(map, 'resize');
              map.setCenter(center);
              $map.removeAttr('style');
            })
          );
        }.bind(this)
      )
      .fail(function() {
        var errorMessage;
        switch (status) {
          case 'ZERO_RESULTS':
            errorMessage = errors.addressNoResults;
            break;
          case 'OVER_QUERY_LIMIT':
            errorMessage = errors.addressQueryLimit;
            break;
          case 'REQUEST_DENIED':
            errorMessage = errors.authError;
            break;
          default:
            errorMessage = errors.addressError;
            break;
        }
        if (Shopify.designMode) {
          $map
          .parent()
          .addClass(classes.mapError)
          .html(
            '<div class="' +
            classes.errorMsg +
            '">' +
            errorMessage +
            '</div>'
          );
        }
      });
    },
    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });
  return Map;
})();
theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    };
    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };
    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };
    if (!$('#ProductJson-' + sectionId).html()) {
      return;
    }
    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );
    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );
    this._initBreakpoints();
    this._stringOverrides();
    this._initVariants();
    this._initImageSwitch();
    this._initAddToCart();
    this._setActiveThumbnail();
  }
  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },
    _initBreakpoints: function() {
      var self = this;
      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider();
          }
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }
          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }
          self.settings.bpSmall = false;
        }
      });
      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },
    _initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState:
        this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };
      this.variants = new slate.Variants(options);
      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      );
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      );
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this)
      );
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      );
    },
    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }
      var self = this;
      $(this.selectors.productThumbImages)
      .on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageId = $el.data('thumbnail-id');
        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);
      })
      .on('keyup', self._handleImageFocus.bind(self));
    },
    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);
      if ($quantityInput.length === 0) return;
      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;
        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );
        if (isInvalidQuantity) {
          $quantityInput
          .attr(
            'aria-describedby',
            'error-quantity-' + self.settings.sectionId
          )
          .attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput
          .removeAttr('aria-describedby')
          .removeAttr('aria-invalid');
        }
      });
    },
    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps + ":not('.hide')").data(
          'image-id'
        );
      }
      var $thumbnail = $(
        this.selectors.productThumbImages +
        "[data-thumbnail-id='" +
        imageId +
        "']"
      );
      $(this.selectors.productThumbImages)
      .removeClass(activeClass)
      .removeAttr('aria-current');
      $thumbnail.addClass(activeClass);
      $thumbnail.attr('aria-current', true);
    },
    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );
      var $otherImages = $(
        this.selectors.productImageWraps +
        ":not([data-image-id='" +
        imageId +
        "'])",
        this.$container
      );
      $newImage.removeClass(this.classes.hidden);
      $otherImages.addClass(this.classes.hidden);
    },
    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;
      $(this.selectors.productFeaturedImage + ':visible').focus();
    },
    _initThumbnailSlider: function() {
      var options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      };
      $(this.selectors.productThumbs).slick(options);
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-list')
      .removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('.slick-disabled')
      .removeAttr('aria-disabled');
      this.settings.sliderActive = true;
    },
    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;
      $(this.selectors.productThumbsWrapper, this.$container)
      .find('[tabindex="-1"]')
      .removeAttr('tabindex');
    },
    _liveRegionText: function(variant) {
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';
      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';
      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
          variant.compare_at_price,
          theme.moneyFormat
        ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }
      liveRegionText = liveRegionText
      .replace('[Regular]', regularLabel)
      .replace('[$$]', regularPrice)
      .replace('[Sale]', saleLabel)
      .replace('[$]', salePrice)
      .trim();
      return liveRegionText;
    },
    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },
    _updateAddToCart: function(evt) {
      var variant = evt.variant;
      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
          $(this.selectors.addToCartText).text(theme.strings.addToCart);
          $(this.selectors.shopifyPaymentButton, this.$container).show();
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.addToCartText).text(theme.strings.soldOut);
          $(this.selectors.shopifyPaymentButton, this.$container).hide();
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.addToCartText).text(theme.strings.unavailable);
        $(this.selectors.shopifyPaymentButton, this.$container).hide();
      }
    },
    _updateAvailability: function(evt) {
      this._updateAddToCart(evt);
      this._updateLiveRegion(evt);
      this._updatePrice(evt);
    },
    _updateImages: function(evt) {
      var variant = evt.variant;
      var imageId = variant.featured_image.id;
      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },
    _updatePrice: function(evt) {
      var variant = evt.variant;
      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);
      $priceContainer
      .removeClass(this.classes.productUnavailable)
      .removeClass(this.classes.productOnSale)
      .removeAttr('aria-hidden');
      if (!variant) {
        $priceContainer
        .addClass(this.classes.productUnavailable)
        .attr('aria-hidden', true);
        return;
      }
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }
    },
    _updateSKU: function(evt) {
      var variant = evt.variant;
      $(this.selectors.SKU).html(variant.sku);
    },
    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });
  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }
  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }
  return Product;
})();
theme.Quotes = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };
  function Quotes(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.quotes-wrapper');
    var slider = (this.slider = '#Quotes-' + sectionId);
    var $slider = $(slider, wrapper);
    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });
    config.slideCount = $slider.data('count');
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }
    $slider.on('init', this.a11y.bind(this));
    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });
    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });
    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }
      sliderObj.slick(args);
      sliderActive = true;
    }
  }
  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);
      $(this.slider, this.wrapper).slick('unslick');
    },
    onBlockSelect: function(evt) {
      var $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },
    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);
      $list.removeAttr('aria-live');
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });
  return Quotes;
})();
theme.slideshows = {};
theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);
    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });
    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }
  return SlideshowSection;
})();
theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },
    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },
    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  }
);
$(document).ready(function() {
  var sections = new theme.Sections();
  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.Filters);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('map', theme.Maps);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('quotes', theme.Quotes);
});
theme.init = function() {
  theme.customerTemplates.init();
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';
  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });
  var iframeSelectors =
      '.rte iframe[src*="youtube.com/embed"],' +
      '.rte iframe[src*="player.vimeo"],' +
      '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
      '.custom__item-inner--html iframe[src*="player.vimeo"]';
  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });
  slate.a11y.pageLinkFocus($(window.location.hash));
  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });
  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)')
  });
  theme.FormStatus.init();
};
$(theme.init);